import {
  MediaDeviceMenu,
  TrackToggle,
  usePersistentUserChoices,
} from "@livekit/components-react";
import { useEffect } from "react";
import { useVideoDeviceId, useVideoEnabled } from "../../hooks/media";
import { LocalVideoTrack, Track } from "livekit-client";
import { FiVideo, FiVideoOff } from "react-icons/fi";
import { useLogEvent } from "../../hooks/log";

export default function CameraToggle(props: {
  initialState?: boolean;
  track?: LocalVideoTrack;
  className?: string;
}) {
  const { saveVideoInputDeviceId } = usePersistentUserChoices();

  // Initialize device settings
  const [videoEnabled, setVideoEnabled] = useVideoEnabled();
  const [videoDeviceId, setVideoDeviceId] = useVideoDeviceId();

  // Save to local storage
  useEffect(() => {
    saveVideoInputDeviceId(videoDeviceId);
  }, [videoDeviceId, saveVideoInputDeviceId]);

  const logEvent = useLogEvent();

  return (
    <>
      <TrackToggle
        className={props.className}
        initialState={props.initialState}
        source={Track.Source.Camera}
        onChange={(enabled, isUserInitiated) => {
          if (isUserInitiated) {
            logEvent({ type: "toggle_camera", details: { enabled: enabled } });
          }
          setVideoEnabled(enabled);
          // Don't save enabled to local storage, bug causing problems
          // if (isUserInitiated) {
          //   saveVideoInputEnabled(enabled);
          // }
        }}
        showIcon={false}
      >
        {videoEnabled ? <FiVideo /> : <FiVideoOff />}
      </TrackToggle>
      {/* Hack: Need to include device menu in same component as track toggle */}
      {props.track && (
        <div style={{ display: "none" }}>
          <MediaDeviceMenu
            initialSelection={videoDeviceId}
            kind="videoinput"
            tracks={{ videoinput: props.track }}
            onActiveDeviceChange={(_, id) => setVideoDeviceId(id)}
          />
        </div>
      )}
    </>
  );
}
